import { Reveal } from "./Reveal";
import { CONSTAT, IMAGES } from "../../data/content";

export const Constat = () => {
  return (
    <section
      id="constat"
      data-testid="constat-section"
      className="relative bg-pblv-bg py-24 md:py-32"
    >
      <div className="mx-auto max-w-[1400px] px-5 md:px-8">
        <div className="grid grid-cols-1 gap-14 lg:grid-cols-12 lg:gap-10">
          {/* Left sticky intro + image */}
          <div className="lg:col-span-5">
            <div className="lg:sticky lg:top-28">
              <Reveal>
                <p className="mb-5 text-xs font-semibold uppercase tracking-[0.25em] text-pblv-mauve">
                  Le constat
                </p>
              </Reveal>
              <Reveal delay={0.1}>
                <h2 className="font-serif text-4xl font-medium leading-[1.05] tracking-tight text-pblv-ink md:text-5xl">
                  Elles portent tout.
                  <br />
                  <span className="italic text-pblv-inksoft">
                    Qui les porte, elles ?
                  </span>
                </h2>
              </Reveal>
              <Reveal delay={0.2}>
                <div className="mt-8 overflow-hidden rounded-[2rem]">
                  <img
                    src={IMAGES.constat}
                    alt="Femme apaisée en pleine nature"
                    className="h-72 w-full object-cover transition-transform duration-[1200ms] hover:scale-105 md:h-96"
                    loading="lazy"
                  />
                </div>
              </Reveal>
            </div>
          </div>

          {/* Right: numbered chapters */}
          <div className="lg:col-span-6 lg:col-start-7">
            <div className="flex flex-col">
              {CONSTAT.map((item, i) => (
                <Reveal
                  key={item.n}
                  delay={i * 0.08}
                  className={`border-t border-pblv-ink/10 py-10 ${
                    i === CONSTAT.length - 1 ? "border-b" : ""
                  }`}
                >
                  <div className="flex items-start gap-6">
                    <span className="font-serif text-2xl font-medium text-pblv-rose">
                      {item.n}
                    </span>
                    <div>
                      <h3 className="font-serif text-2xl font-medium text-pblv-ink md:text-3xl">
                        {item.title}
                      </h3>
                      <p className="mt-3 text-lg leading-relaxed text-pblv-inksoft">
                        {item.body}
                      </p>
                    </div>
                  </div>
                </Reveal>
              ))}
              <Reveal delay={0.1}>
                <p className="mt-10 font-serif text-3xl italic leading-snug text-pblv-mauve md:text-4xl">
                  « Prendre soin des femmes, c'est aussi prendre soin du
                  territoire. »
                </p>
              </Reveal>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Constat;
